import React, { useEffect, useState, useCallback, useMemo } from "react";

import { createClient } from "@supabase/supabase-js";
import moment from "moment";

import "./App.css";
import { PlacingBid } from "./components/placingBid";
import { PlaceBid } from "./components/placeBid";
import { AUCTIONS, reconcileRealtimeUpdateIntoAuction } from "./utils";
import {
  getVariantsAuctionByProductId,
  placeBid,
  fetchGuard,
} from "./lib/auctions";
import { Guard } from "./components/guard";
// import { Settlement } from "./components/settlement";
import { getProto, getScreen } from "./utils/proto";
import OmniAuction from "./components/OmniAuction";
import YouWonScreen from "./screens/YouWon";
import { AuctionBaseCard } from "./components/OmniAuction/AuctionBase/Card";

function App({ domElement }) {
  const now = moment().unix();

  const shopIdData = domElement.getAttribute("data-shop-id");
  const shopId = Number(shopIdData);
  const productIdData = domElement.getAttribute("data-product-id");
  // shopify presents an empty string on the theme customization page.
  // present example auction from engine api.
  const productId = productIdData !== "" ? Number(productIdData) : 1;
  const customerIdData = domElement.getAttribute("data-customer-id");
  const customerId = Number(customerIdData);
  const shopLoginUrlData = domElement.getAttribute("data-shop-login-url");
  const shopLoginUrl = shopLoginUrlData;

  const [loading, setLoading] = useState(true);
  const [variantsAuction, setVariantsAuction] = useState({});
  const [auctionGuard, setAuctionGuard] = useState({});

  const screen = useMemo(() => getScreen(window.location.search), []);

  useEffect(() => {
    let abortController = new AbortController();
    (async () => {
      setLoading(true);
      let _variantsAuction = await getVariantsAuctionByProductId(
        abortController,
        productId
      );
      setVariantsAuction(_variantsAuction);
      setLoading(false);
    })();
    return () => abortController?.abort();
  }, [productId]);

  return (
    <>
      {screen && (
        <>
          {(() => {
            switch (screen) {
              case "YouWon": {
                return <YouWonScreen />;
              }
              default: {
                return <div>unsupported screen</div>;
              }
            }
          })()}
        </>
      )}
      {!screen && (
        <div>
          {!loading && variantsAuction["variants"].length > 0 && (
            <>
              <OmniAuction
                auctionGuard={auctionGuard}
                shopId={shopId}
                productId={productId}
                variantsAuction={variantsAuction}
                customerId={Number(customerId)}
                shopLoginUrl={shopLoginUrl}
                now={now}
              />
            </>
          )}
          {!loading && variantsAuction["variants"].length === 0 && (
            <>
              <AuctionBaseCard productName="no auction yet!">
                <div className="mb-[50px]"></div>
              </AuctionBaseCard>
            </>
          )}
        </div>
      )}
    </>
  );
}

export default App;
